import React from 'react';

import PlaidEndpoint from '../endpoint/plaid-endpoint'
import PlaidProductTypesContainer from './product-types-container/plaid-product-types-container'
import {
  transformItemData,
  transformAccountsData,
  itemCategories,
  accountsCategories
} from '../utils/plaid-data-utilities'

const PlaidItemManagement = () => {
  return (
    <>
      <div className='plaid-item-management'>
        <PlaidProductTypesContainer productType='Item Management'>
          <PlaidEndpoint
            endpoint='item'
            categories={itemCategories}
            schema='/item/get/'
            description='Retrieve information about an Item, like the institution,
        billed products, available products, and webhook
        information.'
            transformData={transformItemData}
          />
          <PlaidEndpoint
            endpoint='accounts'
            schema='/accounts/get'
            categories={accountsCategories}
            description='Retrieve high-level information about all accounts associated with an item.'
            transformData={transformAccountsData}
          />
        </PlaidProductTypesContainer>
      </div>
    </>
  )
}

PlaidItemManagement.displayName = 'Item Management'

export default PlaidItemManagement
